// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"5689818d","213":"cd3eee32","351":"42eeca3f","424":"ecd24737","523":"281bb1a4","594":"d8857103","653":"471ce687","731":"9e6143bc","732":"a8a5e693","863":"1c2c96ab","935":"e8233d34","981":"9fc2b54c"}[chunkId] + ".chunk.js";
};